import codeMessage from "./codeMessage";
const errorHandler=(error)=>{
    const {response} = error;
    if(response && response.status)
    {
         const errorText =  codeMessage[response.status];
       // const { status } = response;
        return errorText;
    }
    else if(navigator.onLine)
     {
            const errorText =  codeMessage[response.status];
            //const { status } = response;
            return errorText;
        }
    

}

export default errorHandler;